import type { FC } from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import { AppStrings } from "../../../utils/constants/AppStrings";

export const AiColumnTitle: FC = () => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
    <span>{AppStrings.PAM_AI}</span>
    <Tooltip title={AppStrings.PAM_AI_ACTION_TOOLTIP}>
      <InfoCircleOutlined
        style={{
          color: "var(--grey-400)",
          fontSize: 12,
          cursor: "help",
        }}
        aria-label={AppStrings.PAM_AI_ACTION_TOOLTIP}
      />
    </Tooltip>
  </span>
);

type AiActionValueProps = {
  eventCategory?: string | null;
};

export const AiActionValue: FC<AiActionValueProps> = ({ eventCategory }) => {
  if (!eventCategory) return <>{AppStrings.PAM_EMPTY_VALUE}</>;
  return <>{eventCategory === "MCP" ? AppStrings.YES : AppStrings.NO}</>;
};
